export default "__VITE_ASSET__BV8h$Kzx__"